import { inject } from '@angular/core';
import { Router, CanActivateFn, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.authReady$.pipe(
        take(1),
        map((authenticated) => {
            if (authenticated && authService.currentUser()) {
                return true;
            }
            return router.createUrlTree(['/auth']);
        })
    );
};
